import { Liquid as O } from "liquidjs";
var x = `{% assign hasKeywords = response.keywords.hits.length > 0 %}
{% assign hasProducts = response.products.hits.length > 0 %}
{% assign hasHistory = history.length > 0 %}
{% assign imagePlaceHolder = 'https://cdn.nosto.com/nosto/9/mock' %}

<div class="ns-autocomplete-results">
  {% if hasKeywords == false and hasProducts == false and hasHistory %}
    <div class="ns-autocomplete-history">
      <div class="ns-autocomplete-header">
        Recently searched
      </div>
      {% for hit in history %}
        <div class="ns-autocomplete-history-item" data-ns-hit="{{ hit | json | escape }}" data-testid="history">
          {{ hit.item }}
          <a
            href="#"
            class="ns-autocomplete-history-item-remove"
            data-ns-remove-history="{{hit.item}}">
            &#x2715;
          </a>
        </div>
      {% endfor %}
    </div>
    <div class="ns-autocomplete-history-clear">
      <button
        type="button"
        class="ns-autocomplete-button"
        data-ns-remove-history="all">
        Clear history
      </button>
    </div>
  {% elsif hasKeywords or hasProducts %}
    {% if hasKeywords %}
      <div class="ns-autocomplete-keywords">
        <div class="ns-autocomplete-header">
          Keywords
        </div>
        {% for hit in response.keywords.hits %}
          <div class="ns-autocomplete-keyword" data-ns-hit="{{ hit | json | escape }}" data-testid="keyword">
            {% if hit._highlight and hit._highlight.keyword %}
              <span>{{ hit._highlight.keyword }}</span>
            {% else %}
              <span>{{ hit.keyword }}</span>
            {% endif %}
          </div>
        {% endfor %}
      </div>
    {% endif %}
    {% if hasProducts %}
      <div class="ns-autocomplete-products">
        <div class="ns-autocomplete-header">
          Products
        </div>
        {% for hit in response.products.hits %}
          <a
            class="ns-autocomplete-product"
            href="{{ hit.url }}"
            data-ns-hit="{{ hit | json | escape }}"
            data-testid="product">
            <img
              class="ns-autocomplete-product-image"
              src="{% if hit.imageUrl %}{{ hit.imageUrl }}{% else %}{{ imagePlaceHolder }}{% endif %}"
              alt="{{ hit.name }}"
              width="60"
              height="40" />
            <div class="ns-autocomplete-product-info">
              {% if hit.brand %}
                <div class="ns-autocomplete-product-brand">
                  {{ hit.brand }}
                </div>
              {% endif %}
              <div class="ns-autocomplete-product-name">
                {{ hit.name }}
              </div>
              <div>
                <span>
                  {{ hit.price }}&euro;
                </span>
                {% if hit.listPrice and hit.listPrice != hit.price %}
                    <span class="ns-autocomplete-product-list-price">
                        {{ hit.listPrice }}
                        &euro;
                    </span>
                {% endif %}
              </div>
            </div>
          </a>
        {% endfor %}
      </div>
    {% endif %}
    <div class="ns-autocomplete-submit">
      <button type="submit" class="ns-autocomplete-button">
        See all search results
      </button>
    </div>
  {% endif %}
</div>
`;
function F(e) {
  const t = O ? new O() : void 0;
  if (t === void 0)
    throw new Error(
      "Liquid is not defined. Please include the Liquid library in your page."
    );
  const i = t.parse(e);
  return async (n, r) => {
    const o = await t.render(i, r);
    n.innerHTML = o;
  };
}
function R() {
  window.nostojs = window.nostojs ?? function(e) {
    (window.nostojs.q = window.nostojs.q ?? []).push(e);
  };
}
async function k(e) {
  return window.nostojs(e);
}
typeof window < "u" && (R(), k((e) => {
  e.internal.getSettings();
})), typeof window < "u" && R();
function b(e, ...t) {
  k((i) => i.internal.logger[e](...t));
}
const h = {
  error: (...e) => b("error", ...e),
  warn: (...e) => b("warn", ...e),
  info: (...e) => b("info", ...e),
  debug: (...e) => b("debug", ...e)
};
function se(e) {
  k((t) => t.recordSearchClick("autocomplete", e));
}
function ae(e) {
  k((t) => t.recordSearchSubmit(e));
}
function G() {
  window.nostojs = window.nostojs ?? function(e) {
    (window.nostojs.q = window.nostojs.q ?? []).push(e);
  };
}
async function P(e) {
  return window.nostojs(e);
}
typeof window < "u" && (G(), P((e) => {
  e.internal.getSettings();
})), typeof window < "u" && G();
function ce(e, t) {
  if (!e.products || !(t != null && t.length))
    return e;
  const i = (n) => t.reduce((r, o) => o(r), n);
  return {
    ...e,
    products: {
      ...e.products,
      hits: e.products.hits.map(i)
    }
  };
}
function ue(e) {
  return new Promise((t) => setTimeout(t, e));
}
async function le(e, t, i) {
  const { maxRetries: n = 0, retryInterval: r = 1e3 } = i;
  let o = 0;
  for (; ; )
    try {
      return await e.search(t, i);
    } catch (s) {
      if (!de(s))
        throw console.info("Skipping retry logic for", s), s;
      if (o >= n)
        throw s;
      o++, await ue(r);
    }
}
function de(e) {
  return !e || typeof e != "object" ? !1 : !("status" in e) || fe(e.status);
}
function fe(e) {
  return typeof e == "number" && (e < 400 || e >= 500);
}
async function pe(e, t = {}) {
  const { hitDecorators: i, ...n } = t, r = await new Promise(P), o = await le(r, e, n);
  return ce(o, i);
}
const me = [
  "productId",
  "url",
  "name",
  "imageUrl",
  "imageHash",
  "thumbUrl",
  "description",
  "brand",
  "variantId",
  "availability",
  "price",
  "priceText",
  "categoryIds",
  "categories",
  "customFields.key",
  "customFields.value",
  "priceCurrencyCode",
  "datePublished",
  "listPrice",
  "unitPricingBaseMeasure",
  "unitPricingUnit",
  "unitPricingMeasure",
  "googleCategory",
  "gtin",
  "ageGroup",
  "gender",
  "condition",
  "alternateImageUrls",
  "ratingValue",
  "reviewCount",
  "inventoryLevel",
  "skus.id",
  "skus.name",
  "skus.price",
  "skus.listPrice",
  "skus.priceText",
  "skus.url",
  "skus.imageUrl",
  "skus.inventoryLevel",
  "skus.customFields.key",
  "skus.customFields.value",
  "skus.availability",
  "pid",
  "onDiscount",
  "extra.key",
  "extra.value",
  "saleable",
  "available",
  "tags1",
  "tags2",
  "tags3"
];
async function I(e, t = {}) {
  const i = e.products?.fields ?? me, n = e.products?.facets ?? ["*"], r = e.products?.size ?? 20, o = e.products?.from ?? 0, s = await pe(
    {
      ...e,
      products: {
        ...e.products,
        fields: i,
        facets: n,
        size: r,
        from: o
      }
    },
    t
  );
  return { query: e, response: s };
}
const H = {
  serpPath: "/search",
  queryParamName: "query",
  enabled: !0
};
function K() {
  return {
    minQueryLength: 2,
    historyEnabled: !0,
    historySize: 5,
    hitDecorators: [],
    nostoAnalytics: !0,
    googleAnalytics: H,
    submit: (e, t, i) => {
      e.length >= (t.minQueryLength ?? K().minQueryLength) && I(
        {
          query: e
        },
        {
          redirect: !0,
          track: t.nostoAnalytics ? "serp" : void 0,
          hitDecorators: t.hitDecorators,
          ...i
        }
      );
    }
  };
}
function ge(e, t, i, n, r, o) {
  let s = [], a = [], d = !0, u = -1;
  function c(l) {
    const g = l?.dataset?.nsHit;
    if (g) {
      const p = T(g);
      if (w(), p?.item) {
        n(p.item);
        return;
      }
      if (p?.keyword) {
        n(p.keyword, {
          redirect: !!p?._redirect,
          isKeyword: !0
        }), p?._redirect && (location.href = p._redirect);
        return;
      }
      p?.url && (location.href = p.url);
    }
  }
  function f() {
    d = !e.innerHTML.trim(), d || (s = Array.from(
      e.querySelectorAll("[data-ns-hit]")
    ).map((l) => (W(l), l)));
  }
  function m() {
    Object.entries(o ?? {}).map(([l, g]) => {
      const p = `[data-ns-${l.replace(/([A-Z])/g, "-$1").toLowerCase()}]`;
      Array.from(e.querySelectorAll(p)).map((y) => {
        const re = y?.dataset?.[`ns${l.charAt(0).toUpperCase() + l.slice(1)}`], M = () => {
          g({
            data: re,
            el: y,
            update: $
          });
        };
        y.addEventListener("click", M), a.push(() => {
          y.removeEventListener("click", M);
        });
      });
    });
  }
  function W(l) {
    const g = () => {
      c(l);
    };
    l.addEventListener("click", g), a.push(() => {
      l.removeEventListener("click", g);
    });
  }
  function A(l, g) {
    if (typeof g == "number" && s[g] && s[g].classList.remove("selected"), typeof l == "number" && s[l]) {
      s[l]?.classList.add("selected");
      const p = s[l]?.dataset?.nsHit;
      if (p) {
        const y = T(p);
        if (y.item) {
          r(y.item);
          return;
        }
        if (y.keyword) {
          r(y.keyword);
          return;
        }
      }
    }
  }
  function L() {
    C(), s = [], a.forEach((l) => l()), a = [];
  }
  async function $(l) {
    L(), await i(e, l), setTimeout(() => {
      f(), m(), j();
    }, 0);
  }
  function w() {
    C(), e.style.display = "none";
  }
  function j() {
    d ? w() : e.style.display = "";
  }
  function X() {
    L(), d = !0, w();
  }
  function _() {
    return e.style.display !== "none";
  }
  function Y() {
    let l = u;
    u === s.length - 1 ? u = 0 : l = u++, A(u, l);
  }
  function ee() {
    if (v()) {
      let l = u;
      u === 0 ? u = s.length - 1 : l = u--, A(u, l);
    } else
      u = s.length - 1, A(u);
  }
  function te() {
    _() && v() && s[u] && c(s[u]);
  }
  function v() {
    return u > -1;
  }
  function ne() {
    return s[u];
  }
  function C() {
    v() && (s[u]?.classList.remove("selected"), u = -1);
  }
  function oe() {
    L(), d = !0, e.innerHTML = "";
  }
  async function ie() {
    const l = await Promise.resolve(t);
    await Promise.resolve(i(e, l)), setTimeout(() => {
      f(), m(), w();
    }, 0);
  }
  return ie(), {
    update: $,
    clear: X,
    isOpen: _,
    goDown: Y,
    goUp: ee,
    handleSubmit: te,
    destroy: oe,
    show: j,
    hide: w,
    resetHighlight: C,
    hasHighlight: v,
    getHighlight: ne,
    container: e
  };
}
function T(e) {
  try {
    return JSON.parse(e) ?? {};
  } catch (t) {
    return h.warn("Could not parse hit", t), {};
  }
}
class B extends Error {
}
function ye(e) {
  let t = !1;
  return {
    promise: new Promise((i, n) => e.then(
      (r) => t ? n(new B("cancelled promise")) : i(r),
      (r) => n(t ? new B("cancelled promise") : r)
    )),
    cancel() {
      t = !0;
    }
  };
}
function he({
  config: e,
  history: t,
  input: i
}) {
  let n;
  const r = (c, f, m) => typeof f.fetch == "function" ? f.fetch(c) : I(
    {
      query: c,
      ...f.fetch
    },
    {
      track: f.nostoAnalytics ? "autocomplete" : void 0,
      redirect: !1,
      hitDecorators: f.hitDecorators,
      ...m
    }
  );
  function o(c) {
    return Promise.resolve({
      query: {
        query: c
      },
      history: t?.getItems()
    });
  }
  function s(c, f) {
    return n?.cancel(), c && c.length >= e.minQueryLength ? (n = ye(r(c, e, f)), n.promise) : t ? o(c ?? "") : (
      // @ts-expect-error type mismatch
      n?.promise ?? Promise.resolve({})
    );
  }
  function a(c) {
    return t && t.add(c), o(i.value);
  }
  function d(c) {
    return t && t.remove(c), o(i.value);
  }
  function u() {
    return t && t.clear(), o(i.value);
  }
  return {
    updateState: s,
    addHistoryItem: a,
    removeHistoryItem: d,
    clearHistory: u
  };
}
function S(e, t) {
  return (typeof e == "string" ? Array.from(document.querySelectorAll(e)) : [e]).filter(
    (i) => t ? i instanceof t : !0
  );
}
function J(e, t) {
  let i = [];
  return S(e).forEach((n) => {
    const r = n.parentNode;
    r !== document && r instanceof Element && (i.push(r), i = i.concat(J(r)));
  }), i.filter(
    (n) => t === void 0
  );
}
function we([e, t], i) {
  const n = (r) => {
    const o = r.target;
    o instanceof HTMLElement && e && o !== e && o !== t && !J(o).includes(e) && i();
  };
  return document.addEventListener("click", n), {
    destroy: () => {
      document.removeEventListener("click", n);
    }
  };
}
function ve(e) {
  e.setAttribute("autocomplete", "off");
}
function ke(e, t) {
  const i = [e].flatMap((n) => {
    const r = [];
    if (t.onSubmit) {
      const o = (a) => {
        t.onKeyDown?.(n.value, a.key), (a.key === "ArrowDown" || a.key === "ArrowUp" || a.key === "Enter") && a.preventDefault();
      };
      n.addEventListener("keydown", o), r.push(() => {
        n.removeEventListener("keydown", o);
      });
      const s = n.form;
      if (s) {
        const a = (d) => {
          d.preventDefault(), t.onSubmit?.(n.value);
        };
        s.addEventListener("submit", a), r.push(() => {
          s?.removeEventListener("submit", a);
        }), Array.from(s.querySelectorAll("[type=submit]")).forEach((d) => {
          const u = (c) => {
            c.preventDefault(), t.onSubmit?.(n.value);
          };
          d.addEventListener("click", u), r.push(() => {
            d.removeEventListener("click", u);
          });
        });
      }
    }
    if (t.onClick) {
      const o = () => {
        t.onClick?.(n.value);
      };
      n.addEventListener("click", o);
    }
    if (t.onFocus) {
      const o = () => {
        t.onFocus?.(n.value);
      };
      n.addEventListener("focus", o);
    }
    if (t.onInput) {
      const o = () => {
        t.onInput?.(n.value);
      };
      n.addEventListener("input", o), r.push(() => {
        n.removeEventListener("input", o);
      });
    }
    return r;
  });
  return {
    destroy() {
      i.forEach((n) => n());
    }
  };
}
const q = "nosto:autocomplete:gaEvent";
function E(e) {
  const {
    delay: t = !1,
    title: i = document.title,
    location: n = window.location.href
  } = e || {};
  if (t)
    be(i, n);
  else {
    if ("gtag" in window && typeof window.gtag == "function") {
      const r = "google_tag_manager" in window && typeof window.google_tag_manager == "object" ? Object.keys(window.google_tag_manager || []).filter((o) => o.substring(0, 2) == "G-") : [];
      if (r.length > 1)
        for (let o = 0; o < r.length; o++)
          window.gtag("event", "page_view", {
            page_title: i,
            page_location: n,
            send_to: r[o]
          });
      else
        window.gtag("event", "page_view", {
          page_title: i,
          page_location: n
        });
    }
    if ("ga" in window && typeof window.ga == "function" && "getAll" in window.ga && typeof window.ga.getAll == "function")
      try {
        const r = new URL(n), o = window.ga.getAll();
        o?.length > 0 && o[0]?.send("pageview", r.pathname + r.search);
      } catch (r) {
        h.warn("Could not send pageview to GA", r);
      }
  }
}
const D = (e) => typeof e.googleAnalytics == "boolean" ? e.googleAnalytics : typeof e.googleAnalytics == "object" && e.googleAnalytics.enabled, N = (e, t) => {
  const i = D(t) ? typeof t.googleAnalytics == "boolean" ? H : {
    ...H,
    ...t.googleAnalytics
  } : void 0;
  if (e && i)
    try {
      return new URL(
        `${i?.serpPath || location.pathname}?${`${encodeURIComponent(
          i.queryParamName
        )}=${encodeURIComponent(e).replace(/%20/g, "+")}`}`,
        window.location.origin
      ).toString();
    } catch (n) {
      h.warn("Could not create track url", n);
      return;
    }
};
function be(e, t) {
  localStorage.setItem(q, JSON.stringify({ title: e, location: t }));
}
function Se() {
  const e = localStorage.getItem(q);
  if (typeof e == "string") {
    localStorage.removeItem(q);
    try {
      const t = JSON.parse(e);
      E(t);
    } catch (t) {
      h.warn("Could not consume pageView", t);
    }
  }
}
setTimeout(Se, 1e3);
function Ee(e) {
  let t, i = !1;
  return (n) => {
    i ? (t && clearTimeout(t), t = setTimeout(async () => {
      await n(), i = !1;
    }, e)) : (n(), i = !0);
  };
}
function Ae(e) {
  const t = "nosto:autocomplete:history";
  let i = n();
  function n() {
    try {
      return JSON.parse(localStorage.getItem(t) ?? "[]") ?? [];
    } catch (u) {
      return h.error("Could not get history items.", u), [];
    }
  }
  function r(u) {
    try {
      localStorage.setItem(t, JSON.stringify(u));
    } catch (c) {
      h.error("Could not set history items.", c);
    }
  }
  function o(u) {
    r(
      i = [{ item: u }, ...i?.filter((c) => c.item !== u) || []].slice(
        0,
        e
      )
    );
  }
  function s() {
    r(i = []);
  }
  function a(u) {
    r(i = i.filter((c) => c.item !== u));
  }
  function d() {
    return i;
  }
  return {
    add: o,
    clear: s,
    remove: a,
    getItems: d
  };
}
function z(e) {
  const t = {
    ...K(),
    ...e
  }, i = t.historyEnabled ? Ae(t.historySize) : void 0, n = Ee(300), r = S(e.inputSelector, HTMLInputElement).map(
    (o) => {
      const s = he({
        config: t,
        history: i,
        input: o
      }), a = Le({
        input: o,
        config: t,
        actions: s
      });
      if (!a)
        return;
      ve(o);
      const d = ke(o, {
        onInput: async (c) => {
          n(async () => {
            const f = await s.updateState(c);
            a.update(f);
          });
        },
        onClick() {
          a.resetHighlight();
        },
        onFocus() {
          a.show();
        },
        onBlur() {
          a.hide();
        },
        onSubmit() {
          U({
            config: t,
            actions: s
          })(o.value), a.hide();
        },
        onKeyDown(c, f) {
          if (f === "Escape")
            a.hide();
          else if (f === "ArrowDown")
            a.isOpen() ? a.goDown() : a.show();
          else if (f === "ArrowUp")
            a.isOpen() && a.goUp();
          else if (f === "Enter")
            if (a.isOpen() && a.hasHighlight()) {
              const m = a.getHighlight()?.dataset?.nsHit;
              m && Q({
                config: t,
                data: m,
                query: o.value
              }), a.handleSubmit();
            } else
              U({
                actions: s,
                config: t
              })(o.value);
        }
      }), u = we(
        [a.container, o],
        () => {
          a.hide();
        }
      );
      return {
        open() {
          a.show();
        },
        close() {
          a.hide();
        },
        destroy() {
          d.destroy(), u.destroy(), a.destroy();
        }
      };
    }
  );
  return {
    destroy() {
      r.forEach((o) => o?.destroy());
    },
    open() {
      r.forEach((o) => o?.open());
    },
    close() {
      r.forEach((o) => o?.close());
    }
  };
}
function Le({
  input: e,
  config: t,
  actions: i
}) {
  const n = typeof t.dropdownSelector == "function" ? S(t.dropdownSelector(e), HTMLElement) : S(t.dropdownSelector, HTMLElement);
  if (n.length === 0) {
    h.error(`No dropdown element found for input ${e}`);
    return;
  } else n.length > 1 && h.error(
    `Multiple dropdown elements found for input ${e}, using the first element`
  );
  const r = n[0];
  return ge(
    r,
    i.updateState(e.value),
    t.render,
    U({
      actions: i,
      config: t
    }),
    (o) => e.value = o,
    {
      removeHistory: async function({ data: o, update: s }) {
        if (o === "all") {
          const a = await i.clearHistory();
          return s(a);
        } else if (o) {
          const a = await i.removeHistoryItem(o);
          return s(a);
        }
      },
      hit: function({ data: o }) {
        o && Q({ config: t, data: o, query: e.value });
      }
    }
  );
}
async function Q({
  config: e,
  data: t,
  query: i
}) {
  if (!e.googleAnalytics && !e.nostoAnalytics)
    return;
  const n = T(t);
  e.nostoAnalytics && n && se(n), D(e) && (n._redirect && E({
    delay: !0,
    location: N(n.keyword, e)
  }), n.url && E({
    delay: !0,
    location: N(i, e)
  }));
}
function U(e) {
  return async (t, i) => {
    const { config: n, actions: r } = e, { redirect: o = !1 } = i ?? {};
    t.length > 0 && (n.historyEnabled && r.addHistoryItem(t), n.nostoAnalytics && ae(t), D(n) && E({
      delay: !0,
      location: N(t, n)
    }), !o && typeof n?.submit == "function" && n.submit(t, n, i));
  };
}
const Ce = {
  defaultCurrency: "EUR",
  defaultLocale: "en-US",
  /** @hidden  */
  currencySettings: {}
}, Pe = {
  EUR: "de-DE",
  GBP: "en-GB",
  USD: "en-US",
  AUD: "en-AU",
  CAD: "en-CA",
  //India, Afghanistan, Bangladesh, Bhutan, Myanmar, Nepal, and Pakistan uses lakhs and crores notation
  INR: "en-IN",
  AFN: "en-IN",
  BDT: "en-IN",
  BTN: "en-IN",
  MMK: "en-IN",
  NPR: "en-IN",
  PKR: "en-IN"
};
function Ie(e = {}) {
  const t = {
    ...Ce,
    ...e
  };
  e.currencySettings || P((n) => {
    t.currencySettings = n.internal.getSettings().currencySettings ?? {};
  });
  function i(n, r) {
    const { defaultCurrency: o, currencySettings: s, defaultLocale: a } = t, d = r ?? o, u = Pe[d] ?? a;
    if (d in s) {
      const c = s[d], f = new Intl.NumberFormat(u, {
        useGrouping: !!c.groupingSeparator,
        minimumFractionDigits: c.decimalPlaces,
        maximumFractionDigits: c.decimalPlaces
      }).formatToParts(n).map((m) => m.type === "group" ? c.groupingSeparator : m.type === "decimal" ? c.decimalCharacter : m.value).join("");
      return c != null && c.currencyBeforeAmount ? `${c.currencyToken}${f}` : `${f}${c?.currencyToken}`;
    }
    return new Intl.NumberFormat(u, {
      style: "currency",
      currency: d
    }).format(n);
  }
  return {
    formatCurrency: i
  };
}
function He(e) {
  const { formatCurrency: t } = Ie(e);
  function i(r, o) {
    const s = {};
    return r.price !== void 0 && (s.priceText = t(r.price, o)), r.listPrice !== void 0 && (s.listPriceText = t(r.listPrice, o)), Object.assign({}, r, s);
  }
  function n(r) {
    return r.price !== void 0 || r.listPrice !== void 0;
  }
  return function(r) {
    if (!n(r))
      return r;
    const o = i(r, r.priceCurrencyCode);
    return o.skus && o.skus.some(n) && (o.skus = o.skus.map((s) => n(s) ? i(s, r.priceCurrencyCode) : s)), o;
  };
}
async function Te(e, { handler: t, defaultTemplate: i }) {
  const n = e.querySelector("script[autocomplete-template]")?.textContent;
  if (!Object.keys(V(e)).length)
    throw new Error("NostoAutocomplete: Missing required config.");
  const r = V(e);
  return await z({
    ...r,
    render: t(n ?? i)
  });
}
function V(e) {
  const t = e.querySelector("script[autocomplete-config]");
  return t ? JSON.parse(t.textContent) : {};
}
class Z extends HTMLElement {
  constructor() {
    super();
  }
  async connectedCallback() {
    return Te(this, {
      handler: F,
      defaultTemplate: x
    });
  }
}
customElements.define("nosto-autocomplete", Z);
export {
  Z as NostoAutocomplete,
  z as autocomplete,
  x as defaultLiquidTemplate,
  F as fromLiquidTemplate,
  He as priceDecorator,
  I as search
};
//# sourceMappingURL=autocomplete.mjs.map
